export default __webpack_public_path__ + "static/media/home-restaurant-img-05.3a1771ea.jpg";